import React, { Fragment } from 'react';
import _ from 'lodash';
import cls from 'classnames';
import {
    faTruck, faSave, faTrashAlt, faPlus, faEdit, faEye, faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEqual } from 'lodash-es';
import {
    Button,
    Col,
    FormGroup,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
} from 'reactstrap';
import { v4 as uuid } from 'uuid';
import { Prompt, withRouter } from 'react-router-dom';
import moment from 'moment';
import {
    AppPageForm,
    FlexCenterRow,
    FlexColumnStart,
    FlexStartRow,
    FormCircularProgress,
    FormDivider,
    FormGroupColumn,
    FormCheckbox,
    GroupedRow,
    onFieldChange,
    onReactSelectChanged,
    SmallOutlineButton,
    SubHeading,
    toasty,
    FormLabel, SmallButton,
} from '../common/forms/FormElements';
import { BaseFormViewModel } from '../common/ViewModel';
import FileUpload from '../common/forms/FileUpload';
import CommonContext, {
    ApiRoutes,
    AppNavPaths,
    SupportedFileExtensions,
    Weekdays,
} from '../Common';
import { Job } from './Job';
import { util } from '../Util';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import AddressFormNew from '../address/AddressFormNew';
import { handleFormSaveError } from '../common/forms/ValidationError';
import { Address } from '../address/Address';
import OrganizationContactForm from '../organization/OrganizationContactForm';
import { Organization, OrganizationContact } from '../organization/Organization';
import JobFileAttachments from './JobFileAttachments';
import { JobOverride } from './JobOverride';
import JobOverrideModal from './JobOverrideModal';

class JobForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.formRef = React.createRef();
        this.uploadsRef = React.createRef();
        this.addressFormRef = React.createRef();
        this.contactFormRef = React.createRef();

        const stateBase = {
            job: new Job(),
            dispatchLocations: [],
            weeks: [],
            usCounties: [],
            addressEditType: null, // from object const
            selectedAddressType: '',
            addressFormTitle: '',
            showTimesheetOverview: false,
            companyContactsOptions: [],
            tableRequired: {},
            meetingLocationRequired: {},
            jobLocationRequired: {},

            // Hauling location dropdowns.
            haulingLocations: [],
            selectedHaulingFromLocation: null,
            selectedHaulingToLocation: null,
            // Which dropdown the 'Add Location' link was clicked from, so the
            // record created by the address form can be selected back into it.
            globalLocationTarget: null,
            pageModified: false,
            selectedContact: null,

            customerSubcontractors: [],
            showContactsForm: false,
            showAddSetupCharge: false,
            showAddPermitFees: false,

            // Property on the job to update with the newly created/edited contact.
            // job.requestedById or formenId.
            selectedContactIdProp: null,

            // Job override options
            showJobOverrideModal: false,
            currentJobOverride: null,

            edit: {
                dayStatuses: {},
                initialResources: null,
                allowRequestedBy: true,
                allowWeekOfDate: true,
                allowForemen: true,
                allowDispatchOfficeLocation: true,
                allowStartTime: true,
                allowWorkOrderNumber: true,
                // Needs special checks - what you can do is more nuanced.
                allowResources: true,
                allowMeetingLocation: true,
                allowJobLocation: true,
                // Currently will always be allowed.
                allowNotes: true,
                allowDelete: false,
                allowSubcontractor: true,
                // Local tracking of resource errors.
                resourceErrors: {},
            },

            resourceTableError: '',
            showDeleteModal: false,
            contactFormIsReadOnly: false,
            allowContactTypeEdit: false,
            ...new BaseFormViewModel(),
        };

        this.state = stateBase;
        this.onChange = this.onChange.bind(this);
        this.onSelectChanged = this.onSelectChanged.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChangeResourceDay = this.onChangeResourceDay.bind(this);
        this.onChangeNonResourceDay = this.onChangeNonResourceDay.bind(this);
        this.onOrganizationContactSaved = this.onOrganizationContactSaved.bind(this);
        this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);
    }

    // #region METHODS
    componentDidMount() { return this.populateState(); }

    setPageModified = (b) => this.setState({ pageModified: b });

    // #region CONTACTS
    onAddContact = (prop) => {
        const { job } = { ...this.state };
        this.context.setFormOpened(true);
        this.contactFormRef.current.resetForm();
        this.setState({
            selectedContact: {
                ...new OrganizationContact(),
                id: null /* new record */,
                companyId:
                    job.contract
                        .companyId /* this will be used to attach the new contact to the location. */,
            },
            selectedContactIdProp: prop,
            showContactsForm: true,
            allowContactTypeEdit: true,
            pageModified: true,
        });
    };

    onAddLocation = (type) => {
        const { job } = this.state;
        const selectedAddress = new Address();
        const addressFormTitle = `${type === 'meetingLocation' ? 'Haul From' : 'Haul To'} Location`;
        this.setState({
            selectedAddressType: type,
            globalLocationTarget: null,
            addressFormTitle,
        });

        // dont show duplicate location if ones filled out already
        let show = true;
        if (job.meetingLocation || job.jobLocation) show = false;

        this.addressFormRef.current.open(
            false,
            selectedAddress,
            addressFormTitle,
            show,
            `Same as ${type === 'meetingLocation' ? 'Haul From' : 'Haul To'
            }`,
        );
    };

    onAddPermitFees = () => {
        this.setState({ showAddPermitFees: false });
    };

    onAddPermitFeesClick = () => {
        this.setState({ showAddPermitFees: true });
    };

    onAddSetupCharge = () => {
        this.setState({ showAddSetupCharge: false });
    };

    onAddSetupChargeClick = () => {
        this.setState({ showAddSetupCharge: true });
    };

    onChange = onFieldChange;

    onChangeNonResourceDay = (nonResource, e) => {
        // prolly do something here
        const { job } = this.state;
        const updated = job.nonResources.map((r) => {
            if (r.id === nonResource.id) {
                return { ...r, [e.target.name]: e.target.checked };
            }
            return { ...r };
        });

        job.nonResources = updated;

        this.setState({ job, pageModified: true });
    };

    onChangeResourceDay = (resource, e) => {
        const { job, edit } = { ...this.state };

        let val = parseInt(e.target.value);

        if (isNaN(val)) {
            val = 0;
        }

        if (val >= 100) {
            toasty.error('Resource assignment cannot exceed 100.');
            return;
        }

        const dayName = e.target.name;
        const { resourceName } = resource;

        // Note: e.target.name === "monday"
        //      resource.resourceName === "Work Truck"
        const msg = this.getResourceEditValidationMessage(
            dayName,
            resourceName,
            val,
        );

        // if we're changing "Flaggers (Planning)"", associate any errors with "Flaggers"
        const nonPlanningResourceName = this.getNonPlanningResourceName(resourceName);

        // Probably a better way of doing this.
        const msgKey = `${nonPlanningResourceName}_${dayName}`;

        if (msg) {
            toasty.error('Resource Update', msg);

            // Flag an error on the resource for the day.
            edit.resourceErrors[msgKey] = msg;
        } else {
            // Noop if it doesn't exist.
            delete edit.resourceErrors[msgKey];
        }

        job.resources = job.resources.map((r) => {
            if (r.id === resource.id) {
                const res = { ...r, [dayName]: `${val}` };
                return res;
            }
            return { ...r };
        });

        job.resources = job.resources.map((r) => {
            if (
                r.isPlanningOnly
                && !this.doesAfadAssignmentExistForDay(job, dayName)
            ) {
                const planningResource = { ...r, [dayName]: '0' };
                return planningResource;
            }

            return { ...r };
        });

        this.setState({ job, edit, pageModified: true });
        this.hydrateDriverCharges();
    };

    async onDeleteConfirmed() {
        const { job } = this.state;
        job.isDeleted = true;

        this.setState({ job });

        await this.saveJob();

        this.setState({ showDeleteModal: false });
    }

    onEditContact = async (prop) => {
        const { job } = { ...this.state };
        const selectedContact = await util.fetch.js(
            ApiRoutes.locationContact.byId(job[prop]),
        );
        this.contactFormRef.current.resetForm();

        await this.setState({
            selectedContact: { ...selectedContact },
            showContactsForm: true,
            selectedContactIdProp: prop,
            allowContactTypeEdit: false,
            pageModified: true,
        });
    };

    onEditLocation = (type, globalLocationTarget) => {
        const { job } = { ...this.state };
        const selectedAddress = { ...job[type] };

        let addressFormTitle = `Edit ${type === 'meetingLocation' ? 'Haul From' : 'Haul To'} Location`;

        let isGlobalAddress = false;
        if (type == 'globalLocation') {
            addressFormTitle = `Add Job Location`;
            isGlobalAddress = true;
        }

        this.setState({
            selectedAddress,
            selectedAddressType: type,
            globalLocationTarget: globalLocationTarget ?? null,
            addressFormTitle,
            pageModified: true,
        });

        selectedAddress.gpsOnly = selectedAddress.latitude != null;

        this.addressFormRef.current.open(isGlobalAddress, selectedAddress, addressFormTitle);
    };

    onOrganizationContactSaved = async () => {
        await this.setState({ contactFormIsReadOnly: true });

        const { selectedContact, selectedContactIdProp, job } = {
            ...this.state,
        };
        const isNew = parseInt(selectedContact.id ?? 0) <= 0;
        const result = await util.fetch.andGetResponse(
            isNew ? util.fetch.types.post : util.fetch.types.put,
            isNew
                ? ApiRoutes.locationContact.create()
                : ApiRoutes.locationContact.update(selectedContact.id),
            { ...selectedContact },
            'Error Saving Contact',
        );

        if (result) {
            toasty.success('Contact saved.');

            // Make the contact the selected one - add returns just the Id, update returns object with id property.
            job[selectedContactIdProp] = result.id ?? result;

            // Refresh the contacts.
            const newOptions = await this.getCompanyContactsOptions(
                job.contract.companyId,
            );

            // Update state.
            this.setState({
                companyContactsOptions: [...newOptions],
                job: { ...job },
                showContactsForm: false,
                saving: false,
            });
        } else {
            this.setState({ saving: false });
        }

        await this.setState({ contactFormIsReadOnly: false });
    };
    // #endregion

    onPermitFeesApplyChange = () => {
        const { job } = this.state;

        job.permitFeesApply = !job.permitFeesApply;

        this.setState({ job });
    };

    onPreviewDrop = (files) => {
        this.setState({
            files: this.state.files.concat(files),
        });
    };

    onRemoveAttachment = async (file) => {
        const { job } = { ...this.state };
        const url = ApiRoutes.job.attachment(job.id);
        const resp = await util.fetch.delete(url, file, util.fetch.format.json);
        if (resp) {
            toasty.success('Attachment removed.');
            this.getAttachments();
        } else {
            toasty.error(
                'There was a either a problem removing the attachment or it has already been removed.  Please try your request again after refreshing the page.',
            );
        }
    };

    /**
     * Whether there is a street address worth printing under the dropdown.
     * Deliberately does not trust a gpsOnly flag - locations arriving from the
     * contract defaults or the type-ahead don't reliably carry one, and a
     * missing flag shouldn't blank out an address the user can see.
     */
    hasStreetAddress = (location) => !!location
        && !!(location.address1 || location.city || location.state || location.zip);

    /**
     * Match a location already on the job back to a record in the hauling
     * location list so the dropdown can show it as the current selection on
     * load.
     *
     * Deliberately tries several keys.  Contract defaults arrive with their id
     * blanked out, and a location that was hand-entered through the address
     * form carries an address but no name, so matching on any single field
     * leaves one of the two dropdowns empty.
     */
    findHaulingLocation = (locations, location) => {
        if (!location) return null;

        const list = locations ?? [];
        if (!list.length) return null;

        // 1. Same record.
        if (location.id != null) {
            const byId = list.find((x) => x.id === location.id);
            if (byId) return byId;
        }

        const norm = (value) => (value ?? '').toString().trim().toLowerCase();

        // Normalize both sides so it doesn't matter whether the fields sit on
        // the record itself or on its nested company.
        const target = this.haulingLocationToAddress(location);
        const candidates = list.map((option) => ({
            option,
            address: this.haulingLocationToAddress(option),
        }));

        // 2. Same name.
        if (norm(target.locationName)) {
            const byName = candidates.find(
                (c) => norm(c.address.locationName) === norm(target.locationName),
            );
            if (byName) return byName.option;
        }

        // 3. Same street address, for locations that carry no name.
        if (norm(target.address1)) {
            const byAddress = candidates.find((c) => {
                if (norm(c.address.address1) !== norm(target.address1)) return false;

                // Only let the zip veto a match when both sides have one.
                if (norm(target.zip) && norm(c.address.zip)) {
                    return norm(c.address.zip) === norm(target.zip);
                }

                return true;
            });
            if (byAddress) return byAddress.option;
        }

        // 4. Same coordinates, for GPS-only locations.
        if (target.latitude != null && target.longitude != null) {
            const byCoords = candidates.find(
                (c) => c.address.latitude != null
                    && c.address.longitude != null
                    && Number(c.address.latitude) === Number(target.latitude)
                    && Number(c.address.longitude) === Number(target.longitude),
            );
            if (byCoords) return byCoords.option;
        }

        return null;
    };

    /**
     * A location is GPS-only when there is no street address to display but we
     * do have coordinates instead.  A missing city on its own is not enough -
     * that just means the record didn't carry one.
     *
     * @param {any} location an address-shaped object
     */
    isGpsOnly = (location) => !!location
        && !location.address1
        && !location.city
        && !!(location.latitude || location.longitude);

    /**
     * Hauling location records come back from the type-ahead shaped as
     * { id, company: { companyName, address1, city, state, zip, ... } }.
     * The Haul From / Haul To display underneath each dropdown, and the job
     * payload itself, both expect a flat address, so normalize the selection
     * before it is assigned to the job.
     *
     * @param {any} location a record from state.haulingLocations
     */
    haulingLocationToAddress = (location) => {
        if (!location) return null;

        const company = location.company ?? {};

        // Depending on the endpoint, the address fields come back either on the
        // company record or flattened onto the location itself, so check both.
        const pick = (field) => company[field] ?? location[field] ?? null;

        const address1 = pick('address1');
        const city = pick('city');
        const latitude = pick('latitude');
        const longitude = pick('longitude');

        return {
            id: location.id,
            locationName: company.companyName
                ?? company.name
                ?? location.locationName
                ?? location.name,
            address1,
            address2: pick('address2'),
            city,
            state: pick('state'),
            zip: pick('zip'),
            latitude,
            longitude,
            gpsOnly: this.isGpsOnly({
                address1, city, latitude, longitude,
            }),
        };
    };

    /**
     * Label for the hauling location dropdowns.  Guarded because ad-hoc
     * addresses (entered through AddressFormNew) have no company record.
     */
    haulingLocationLabel = (option) => option?.company?.companyName
        ?? option?.locationName
        ?? '';

    onHaulFromLocationSelected = (selection) => {
        const { job } = this.state;

        job.meetingLocation = this.haulingLocationToAddress(selection);

        this.setState({
            job: { ...job },
            selectedHaulingFromLocation: selection ?? null,
            ...(job.meetingLocation ? { meetingLocationRequired: {} } : {}),
            pageModified: true,
        });
    };

    onHaulToLocationSelected = (selection) => {
        const { job } = this.state;

        job.jobLocation = this.haulingLocationToAddress(selection);

        this.setState({
            job: { ...job },
            selectedHaulingToLocation: selection ?? null,
            ...(job.jobLocation ? { jobLocationRequired: {} } : {}),
            pageModified: true,
        });
    };

    onSaveAddress = async (address) => {
        let {
            contractId,
            job,
            selectedAddressType,
            globalLocationTarget,
            meetingLocationRequired,
            jobLocationRequired,
        } = this.state;

        if (address.id == undefined) {
            address.id = uuid();
        }

        if (!address.gpsOnly) {
            address.latitude = null;
            address.longitude = null;
        }

        // A global location is posted to the server, then re-read so that the
        // newly created record can be selected in the dropdown it was added from.
        if (selectedAddressType === 'globalLocation') {
            const org = new Organization();

            org.name = address.locationName;
            org.address1 = address.address1;
            org.city = address.city;
            org.state = address.state;
            org.zip = address.zip;
            org.notes = address.description;
            // Send the coordinates up with the create as well.  The dedicated
            // coords endpoint below still runs, but if the create accepts them
            // the re-read list already carries them and nothing depends on the
            // ordering of the two calls.
            org.latitude = address.latitude ?? null;
            org.longitude = address.longitude ?? null;
            org.types.push(11);

            const priorIds = new Set(
                (this.state.haulingLocations ?? []).map((x) => x.id),
            );

            await util.fetch
                .post(ApiRoutes.company.createHaulingLocation(address.global ? 0 : contractId), org)
                .catch(this.handleSaveError);

            const haulingLocations = await util.fetch.js(
                ApiRoutes.typeAheads.haulingLocations(contractId),
            );

            // The record that wasn't in the list before the POST is the new one.
            // Fall back to a name match if the ids can't be diffed.
            const created = (haulingLocations ?? []).find(
                (x) => !priorIds.has(x.id),
            ) ?? (haulingLocations ?? []).find(
                (x) => (x.company?.companyName ?? '') === org.name,
            );

            const next = { haulingLocations, pageModified: true };

            if (created) {
                await util.fetch
                    .post(ApiRoutes.company.updateHaulingLocationCoords(
                        created.company.id,
                        address.latitude,
                        address.longitude,
                    ))
                    .catch(this.handleSaveError);

                // The list above was read before the coordinates were saved, so
                // the record we just found has no lat/lng on it.  Graft the
                // values the user entered on locally - without them
                // haulingLocationToAddress can never classify a location with
                // no street address as GPS-only.
                created.company = {
                    ...(created.company ?? {}),
                    latitude: address.latitude ?? null,
                    longitude: address.longitude ?? null,
                };

                // Which dropdown the 'Add Location' link was clicked from.
                // Defaults to Haul From when the caller didn't say.
                const isFrom = globalLocationTarget !== 'haulingToLocation';

                job[isFrom ? 'meetingLocation' : 'jobLocation'] = this.haulingLocationToAddress(created);

                next.job = { ...job };
                next[
                    isFrom
                        ? 'selectedHaulingFromLocation'
                        : 'selectedHaulingToLocation'
                ] = created;

                if (isFrom) next.meetingLocationRequired = {};
                else next.jobLocationRequired = {};
            }

            this.setState(next);

            return;
        }

        job[selectedAddressType] = { ...address };

        if (address.duplicate) {
            // if the other is blank fill it in.
            if (selectedAddressType === 'jobLocation' && !job.meetingLocation) {
                const mAddress = util.object.clone(address);
                mAddress.id = uuid();

                job.meetingLocation = mAddress;
            }

            if (selectedAddressType === 'meetingLocation' && !job.jobLocation) {
                const jAddress = util.object.clone(address);
                jAddress.id = uuid();

                job.jobLocation = jAddress;
            }
        }

        if (job.meetingLocation) meetingLocationRequired = {};

        if (job.jobLocation) jobLocationRequired = {};

        this.setState({
            job,
            meetingLocationRequired,
            jobLocationRequired,
            // A hand-entered address isn't one of the dropdown options, so clear
            // the selection for whichever side was edited.
            ...(selectedAddressType === 'meetingLocation'
                ? { selectedHaulingFromLocation: null }
                : {}),
            ...(selectedAddressType === 'jobLocation'
                ? { selectedHaulingToLocation: null }
                : {}),
        });
    };

    onSelectChanged = onReactSelectChanged;

    onSubmit = async (e) => {
        const { job, newLocationContacts } = { ...this.state };

        if (!this.validateSetupCharges()) {
            return false;
        }

        if (!this.onValidate()) return false;

        if (this.state.saving) return false;

        this.setState({ saving: true });

        // Revert uuid
        if (job.meetingLocation != null && job.meetingLocation.id != null) {
            job.meetingLocation.id = job.meetingLocation.id.constructor === String
                ? null
                : job.meetingLocation.id;
        }

        if (job.jobLocation != null && job.jobLocation.id != null) {
            job.jobLocation.id = job.jobLocation.id.constructor === String
                ? null
                : job.jobLocation.id;
        }

        job.resources = job.resources.map((r) => {
            r.id = r.id.constructor === String ? null : r.id;
            return r;
        });

        job.overrides = job.overrides?.map((o) => ({
            ...o,
            weekOfDate: job.weekOfDate,
            job: {
                weekOfDate: job.weekOfDate,
            },
        }));

        // Include new contacts
        job.newLocationContacts = newLocationContacts;

        this.setState({
            originalJob: util.object.clone(job),
            pageModified: false,
        });

        // Clear any fluent api errors
        this.clearErrors();
        job.id ? this.saveJob() : this.createJob();
    };

    onValidate = () => {
        let {
            job,
            tableRequired,
            meetingLocationRequired,
            jobLocationRequired,
            edit,
            resourceTableError,
        } = this.state;

        let valid = true;

        tableRequired = {};
        meetingLocationRequired = {};
        jobLocationRequired = {};

        const requiredStyle = {
            border: '1px solid',
            borderRadius: '0.25rem',
            borderColor: '#ed1c24',
        };

        // The var sum below is unused?
        // Resources
        // at least 1 day on the entire grid needs to be 1 or more.  So sum entire grid and greater than 0
        resourceTableError = '';
        // let sum = 0;
        // (job.resources ?? []).forEach(x => {
        //    sum += parseInt(x.sunday) + parseInt(x.monday) + parseInt(x.tuesday) + parseInt(x.wednesday) + parseInt(x.thursday) + parseInt(x.friday) + parseInt(x.saturday);
        // });

        // Bypass this per CW
        // if (sum === 0) {
        //    valid = false;

        //    resourceTableError += "At least 1 resource is required for a job. ";

        //    tableRequired = requiredStyle;
        // }

        // Resources - added after "At least 1 resource" check.
        // Only applicable to job edits - not new jobs.
        const resourceErrorKeys = Object.keys(edit.resourceErrors);
        if (resourceErrorKeys.length > 0) {
            valid = false;

            resourceErrorKeys.forEach(
                (key) => (resourceTableError += `${edit.resourceErrors[key]} `),
            );

            tableRequired = requiredStyle;
        }

        // Locations
        if (!job.meetingLocation) {
            valid = false;
            meetingLocationRequired = requiredStyle;
        }

        if (!job.jobLocation) {
            valid = false;
            jobLocationRequired = requiredStyle;
        }

        this.setState({
            formValidated: valid,
            saving: valid,
            tableRequired,
            meetingLocationRequired,
            jobLocationRequired,
            resourceTableError,
        });

        return valid;
    };

    getAttachments = async () => {
        const { job } = { ...this.state };
        const attachments = await util.fetch.get(
            ApiRoutes.job.getAllAttachments(job.id),
        );
        job.uploads = attachments ?? [];
        this.setState({ job });
    };
    // #endregion

    getCompanyContactsOptions = async (
        companyId,
        constrainContactTypes,
        requestedById,
        foremanId,
    ) => {
        const companyContacts = await util.fetch.js(
            ApiRoutes.company.contacts(companyId),
        );

        // TODO: Define and filter server-side.
        const descs = OrganizationContactForm.filteredContactTypes;

        const contactsFiltered = companyContacts.filter((c) => {
            if (!c.isActive) return false;

            // Automatically include if we're not constraining contact types.
            // Include if the contact was already set as the "requested by" or foreman person.
            const include = !constrainContactTypes
                || c.id === requestedById
                || c.id === foremanId
                || (c.locationContactTypes
                    && c.locationContactTypes.some((t) => descs.some((d) => t.description === d)));

            return include;
        });

        const contactsMapped = contactsFiltered.map((x) => ({
            label: x.contactName,
            value: x.id,
        }));

        // const contactsMapped = [...companyContacts.filter((c) => c.isActive).map(x => { return { label: x.contactName, value: x.id } })];
        return contactsMapped;
    };

    getCounty = (location) => {
        if (!location || !location.usCountyId) {
            return null;
        }

        const { usCounties } = this.state;

        const county = usCounties.find((c) => c.id == location.usCountyId);

        return county || null;
    };

    getExistingOverrideDay = (day) => {
        const { job } = { ...this.state };

        const overrideDay = Weekdays[day.getDay()].name;
        const existingOverride = (job.overrides ?? []).find((override) => override.overrideDay === overrideDay && !override.isDeleted);

        return existingOverride;
    };

    getNonPlanningResourceName(resourceName) {
        return resourceName.startsWith('Flagger')
            ? resourceName.split(' ')[0]
            : null;
    }

    /**
     * For cases where we have paired planning/resource versions of job resources
     * (as in the case of of "Flaggers" and "Flaggers (Planning)"), find the
     * paired version of the resource and extract its resource
     * count for the given day.
     * Planning resources are enabled by the EnableRequestedPersonnel tenant setting.
     * @param {*} resourceName
     * @param {*} day
     * @returns
     */
    getPairedResourceCount(resourceName, day) {
        const { job, tenantSettings } = this.state;

        if (!tenantSettings || !tenantSettings.enableRequestedPersonnel) {
            return null;
        }

        const nonPlanningResourceName = this.getNonPlanningResourceName(resourceName);

        if (nonPlanningResourceName == null) {
            return null;
        }

        const isNonPlanningResource = resourceName == nonPlanningResourceName;

        const alternateResource = job.resources.find(
            (r) => r.resourceName !== resourceName
                && r.resourceName.startsWith(nonPlanningResourceName),
        );

        if (
            !alternateResource
            // if we're editing Flaggers and Flaggers (Planning) is disabled because
            // an AFAD resource hasn't been assigned for the day, a zero value
            // on Flaggers (Planning) is not an issue
            || (isNonPlanningResource
                && !this.doesAfadAssignmentExistForDay(job, day))
        ) {
            return null;
        }

        return alternateResource[day];
    }

    getResourceEditValidationMessage(day, resourceName, val) {
        // You want a null message - means everything is OK.
        let msg = null;

        const resourceStatus = this.getResourceStatus(day, resourceName);

        if (resourceStatus && resourceStatus.statusCounts) {
            const maxStatus = resourceStatus.maxConfirmationStatusId;

            // If nothing has been assigned, you can edit whatever you'd like.
            if (maxStatus < 2) return null;

            // If the max status is "Scheduled", you cannot edit the value to go below assigned resources.
            // If the max status is 3 or 4, you can only add resources - number must be greater than the
            // counts of all statuses.
            const minCheckStatus = maxStatus === 2 ? 2 : 1;

            const threshold = Object.keys(resourceStatus.statusCounts).reduce(
                (acc, currentStatus) => {
                    // Set an upper limit of 4 in case we add future statuses.
                    if (currentStatus >= minCheckStatus && currentStatus <= 4) acc += resourceStatus.statusCounts[currentStatus];

                    return acc;
                },
                0,
            );

            if (val < threshold) {
                const du = `${day[0].toUpperCase()}${day.substring(1)}`;

                switch (maxStatus) {
                case 2:
                    msg = `"${resourceName}" must be at least ${threshold} on ${du} because of existing assignments.`;
                    break;
                case 3:
                case 4:
                    msg = `"${resourceName}" must be at least ${threshold} on ${du} because notifications have already been sent.`;
                    break;
                default:
                    break;
                }
            }
        }

        if (!msg) {
            const pairedResourceCount = this.getPairedResourceCount(
                resourceName,
                day,
            );

            if (pairedResourceCount !== null) {
                const uppercaseDay = `${day[0].toUpperCase()}${day.substring(
                    1,
                )}`;

                const isPlanning = resourceName.includes('Planning');

                if (isPlanning && Number(pairedResourceCount) > Number(val)) {
                    msg = `"${resourceName}" is fewer than the currently defined ${pairedResourceCount} resources on ${uppercaseDay}.`;
                } else if (
                    !isPlanning
                    && Number(pairedResourceCount) < Number(val)
                ) {
                    msg = `"${resourceName}" must be less than or equal to ${pairedResourceCount} on ${uppercaseDay} because of the configured planning count.`;
                }
            }
        }

        return msg;
    }

    getResourceStatus(day, resourceName) {
        let resourceStatus = null;

        const { edit } = this.state;

        if (
            edit.dayStatuses
            && edit.dayStatuses[day]
            && edit.dayStatuses[day].resourceStatuses
            && edit.dayStatuses[day].resourceStatuses[resourceName]
        ) {
            resourceStatus = edit.dayStatuses[day].resourceStatuses[resourceName];
        }

        return resourceStatus;
    }

    getWeekValuesArrayOrdered = (jobWeek) => {
        // Safari sometimes reads this in the wrong format - it should always be stored as YYYY-MM-DD
        const formats = ['YYYY-MM-DD', 'L-d-YYYY'];
        let startDate;

        formats.forEach((format) => {
            const date = moment(jobWeek, format);

            if (date.isValid()) {
                startDate = date.toDate();
            }
        });

        const dates = [];
        dates.push(startDate);
        for (let i = 1; i < 7; i++) {
            dates.push(
                moment(dates[i - 1])
                    .add(1, 'day')
                    .toDate(),
            );
        }
        return dates;
    };

    clearErrors = () => this.setState({ errors: {} });

    createJob = async () => {
        const { job } = this.state;

        const response = await util.fetch.post(
            ApiRoutes.job.create(),
            job,
            util.fetch.format.none,
        );
        this.processSaveResponse(response);
    };

    doesAfadAssignmentExistForDay = (job, dayName) => {
        if (!job.resources) {
            return false;
        }

        return job.resources.some(
            (r) => this.resourceIsAfad(r) && r[dayName] && r[dayName] > 0,
        );
    };

    handleClickResourceDay = (day) => {
        const override = this.getExistingOverrideDay(day) || new JobOverride(day);

        this.setState({
            showJobOverrideModal: true,
            currentJobOverride: {
                ...override,
                job: this.state.job,
            },
        });
    };

    handleCloseJobOverride = (data) => {
        if (data) {
            const { job } = { ...this.state };
            const overrides = (job.overrides ?? []);

            // Remove circular references
            data.job = {
                weekOfDate: data.job.weekOfDate,
            };

            const existingOverride = overrides.findIndex((override) => override.overrideDay === data.overrideDay);

            if (existingOverride === -1) {
                overrides.push(data);
            } else {
                overrides[existingOverride] = data;
            }

            this.setState({
                showJobOverrideModal: false,
                currentJobOverride: null,
                job: {
                    ...job,
                    overrides,
                },
            });
        } else {
            this.setState({
                showJobOverrideModal: false,
                currentJobOverride: null,
            });
        }
    };

    handleSaveError = handleFormSaveError;

    //hydrateSetupCharges = () => {
    //    const { job } = { ...this.state };

    //    job.resources = job.resources.map((r) => {
    //        const flaggersRow = job.resources.filter((r) => r.isPlanningOnly == false && r.resourceName == 'Flaggers')[0];

    //        if (r.setupChargeTypeId > 0 && (r.isNew == true || this.resourceHasAnyAssignments(r))) {
    //            r.monday = flaggersRow.monday > 0 ? 1 : 0;
    //            r.tuesday = flaggersRow.tuesday > 0 ? 1 : 0;
    //            r.wednesday = flaggersRow.wednesday > 0 ? 1 : 0;
    //            r.thursday = flaggersRow.thursday > 0 ? 1 : 0;
    //            r.friday = flaggersRow.friday > 0 ? 1 : 0;
    //            r.saturday = flaggersRow.saturday > 0 ? 1 : 0;
    //            r.sunday = flaggersRow.sunday > 0 ? 1 : 0;
    //        }

    //        return { ...r };
    //    });

    //    this.setState({ job });
    //};

    hydrateDriverCharges = () => {
        const { job } = { ...this.state };

        // Set a min on the driver basd on equipment with "requires driver" for that day
        const driverRow = job.resources.filter((r) => r.jobResourceTypeId == 1)[0];

        const sundayDriversRequired = job.resources.filter((r) => r.isDriverRequired == true && parseInt(r.sunday) > 0)
            .reduce((a, b) => a + parseInt(b.sunday), 0);
        const mondayDriversRequired = job.resources.filter((r) => r.isDriverRequired == true && parseInt(r.monday) > 0)
            .reduce((a, b) => a + parseInt(b.monday), 0);
        const tuesdayDriversRequired = job.resources.filter((r) => r.isDriverRequired == true && parseInt(r.tuesday) > 0)
            .reduce((a, b) => a + parseInt(b.tuesday), 0);
        const wednesdayDriversRequired = job.resources.filter((r) => r.isDriverRequired == true && parseInt(r.wednesday) > 0)
            .reduce((a, b) => a + parseInt(b.wednesday), 0);
        const thursdayDriversRequired = job.resources.filter((r) => r.isDriverRequired == true && parseInt(r.thursday) > 0)
            .reduce((a, b) => a + parseInt(b.thursday), 0);
        const fridayDriversRequired = job.resources.filter((r) => r.isDriverRequired == true && parseInt(r.friday) > 0)
            .reduce((a, b) => a + parseInt(b.friday), 0);
        const saturdayDriversRequired = job.resources.filter((r) => r.isDriverRequired == true && parseInt(r.saturday) > 0)
            .reduce((a, b) => a + parseInt(b.saturday), 0);

        driverRow.sunday = parseInt(driverRow.sunday) < parseInt(sundayDriversRequired) ? parseInt(sundayDriversRequired) : driverRow.sunday;
        driverRow.monday = parseInt(driverRow.monday) < parseInt(mondayDriversRequired) ? parseInt(mondayDriversRequired) : driverRow.monday;
        driverRow.tuesday = parseInt(driverRow.tuesday) < parseInt(tuesdayDriversRequired) ? parseInt(tuesdayDriversRequired) : driverRow.tuesday;
        driverRow.wednesday = parseInt(driverRow.wednesday) < parseInt(wednesdayDriversRequired) ? parseInt(wednesdayDriversRequired) : driverRow.wednesday;
        driverRow.thursday = parseInt(driverRow.thursday) < parseInt(thursdayDriversRequired) ? parseInt(thursdayDriversRequired) : driverRow.thursday;
        driverRow.friday = parseInt(driverRow.friday) < parseInt(fridayDriversRequired) ? parseInt(fridayDriversRequired) : driverRow.friday;
        driverRow.saturday = parseInt(driverRow.saturday) < parseInt(saturdayDriversRequired) ? parseInt(saturdayDriversRequired) : driverRow.saturday;

        this.setState({ job });
    };

    isRequestedPersonnelSectionAvailable = () => {
        const { job } = this.state;

        return (
            job.resources
            && job.resources.some((r) => r.isPlanningOnly)
            && job.resources.some(
                (r) => this.resourceIsAfad(r) && this.resourceHasAnyAssignments(r),
            )
        );
    };

    notifyError = (message) => toasty.error(
        'Save Unsuccessful',
        <FlexColumnStart>
            <span>There was a server error when saving:</span>
            {!!message && (
                <span className="pt-2 pb-2 font-weight-bold">{`${message}`}</span>
            )}
            <span>
                Please try your request again or contact support for
                assistance.
            </span>
        </FlexColumnStart>,
    );

    notifySuccess = () => toasty.success('Job Saved', 'Job saved successfully.');

    overrideDayIsDisabled = (day) => {
        const now = moment();

        const selectedDay = typeof day === 'string' ? moment(day, moment.ISO_8601) : moment(day);

        // Restrict overrides to 7PM the previous day
        selectedDay.subtract(5, 'hours');

        return now.isAfter(selectedDay);
    };

    populateState = async () => {
        let { showTimesheetOverview, edit } = { ...this.state };

        // Route params
        // Can route in from a contract page, or from job search, which can pull job by its ID
        // possibly add a way to select contract on here that job will assign to?
        const jobId = this.props.match.params.id; // {job/1}
        const { contractId } = this.props.match.params; // {newJob/1}

        // Promises
        const pDispatchLocs = util.fetch.js(
            ApiRoutes.typeAheads.dispatchLocations(),
        );
        const pJobManage = jobId
            ? util.fetch.js(ApiRoutes.job.byId(jobId))
            : { job: new Job(), edit: {}, constrainContactTypes: true };

        const pContract = jobId
            ? null
            : util.fetch.js(ApiRoutes.contract.byId(contractId)); // if new job, get the contract
        const pResources = jobId
            ? null
            : util.fetch.js(ApiRoutes.job.getResources(contractId)); // if new job, get the resources
        const pWeeks = util.fetch.js(ApiRoutes.job.weeks());

        let [
            dispatchLocations,
            jobManage,
            contract,
            resources,
            weeks,
            usCounties,
            tenantSettings
        ] = await Promise.all([
            pDispatchLocs,
            pJobManage,
            pContract,
            pResources,
            pWeeks,
            util.fetch.js(ApiRoutes.USCounties.all()),
            util.fetch.js(ApiRoutes.tenant.settings())
        ]);

        const { job } = jobManage;
        var haulingLocations = [];

        // On an existing job the route carries the job id, not the contract id,
        // so fall back to the id on the job itself - otherwise the type-ahead is
        // queried with undefined and the dropdowns come back empty.
        const haulingContractId = contractId ?? job.contractId ?? job.contract?.id ?? null;

        haulingLocations = await util.fetch.js(ApiRoutes.typeAheads.haulingLocations(haulingContractId));

        if (!jobId) {
            job.contract = contract;

            // If it's a new job and there's only 1 dispatch location, set it.
            if (dispatchLocations.length === 1) job.dispatchOfficeLocationId = dispatchLocations[0].value;

            if (job.contract) {
                dispatchLocations = dispatchLocations.filter((x) => (contract.dispatchLocations ?? []).includes(x.value));
                job.contractId = job.contract.id; // may need to gut this later
                job.description = job.contract.description;

                if (job.contract.haulFromLocation != null && job.meetingLocation == null) {
                    job.meetingLocation = job.contract.haulFromLocation;
                    job.meetingLocation.id = null;
                }

                if (job.contract.haulToLocation != null && job.jobLocation == null) {
                    job.jobLocation = job.contract.haulToLocation;
                    job.jobLocation.id = null;
                }

                job.foremenId = job.contract.lastForemenId;
                job.requestedById = job.contract.lastRequestedById;
            }
        } else {
            showTimesheetOverview = job.resources.filter((x) => x.typeName === 'None').length > 0;
        }

        if (resources) {
            job.resources = resources.map((r) => {
                if (r.id === 0) r.id = uuid();
                if (r.id === 0 && r.setupChargeTypeId > 0 && !r.isPermit) r.isNew = true;
                return r;
            });
            showTimesheetOverview = resources.filter((x) => x.typeName === 'None').length > 0;
        }

        // Week selector setup
        if (!!(job.id ?? 0) > 0) {
            /** The job exists and we don't really support week start changes, so clear it out, set the existing job's week
                as the only week in the array, and lock it down. */
            weeks = [];
            weeks.push({ label: job.weekOfDate, value: job.weekOfDate });
        } else {
            // Reduce the server-calculated weeks down to last week, the current week, and next week.
            const startOfCurrentWeek = moment().startOf('week');
            const startOfLastWeek = moment().subtract(1, 'week').startOf('week');
            const startOfNextWeek = moment().add(1, 'week').startOf('week');
            weeks = weeks.filter((x) => {
                const weekStart = moment(x.startDisplay).startOf('week');
                return weekStart.isSame(startOfCurrentWeek, 'day')
                    || weekStart.isSame(startOfLastWeek, 'day')
                    || weekStart.isSame(startOfNextWeek, 'day');
            });

            // Get the calculated weeks from the tenant settings, and select the first by default
            weeks = weeks.map((x) => ({ label: x.startDisplay, value: x.startDisplay }));
            // if its monday, we allow one week in past, so select currect index 1, else index 0(for not monday)
            if (new Date().getDay() === 1) {
                job.weekOfDate = weeks[1].value;
            } else {
                job.weekOfDate = weeks[0].value;
            }
        }

        const companyContactsOptions = await this.getCompanyContactsOptions(
            job.contract.companyId,
            jobManage.constrainContactTypes,
            job.requestedById,
            job.foremenId,
        );

        // Copy updated edit permissions.
        edit = Object.assign(edit, jobManage.edit);
        if (job.resources) edit.initialResources = { ...job.resources };

        const customerId = job.contract.companyId;
        const customerSubcontractors = await util.fetch.js(
            ApiRoutes.typeAheads.subcontractors(customerId),
        );

        const originalJob = util.object.clone(job);

        let [
            materials
        ] = await Promise.all([
            util.fetch.js(ApiRoutes.typeAheads.contractMaterials(job.contract.id))
        ]);

        this.setState((state) => ({
            weeks: [...weeks],
            loading: false,
            saving: false,
            dispatchLocations: [...dispatchLocations],
            customerSubcontractors: [...customerSubcontractors],
            job: { ...job },
            edit: { ...edit },
            showTimesheetOverview,
            companyContactsOptions: [...companyContactsOptions],
            usCounties,
            tenantSettings,
            originalJob,
            materials,
            haulingLocations,
            // Show whatever the job already points at as the current dropdown
            // selection instead of leaving both lists blank on load.
            selectedHaulingFromLocation: this.findHaulingLocation(
                haulingLocations,
                job.meetingLocation,
            ),
            selectedHaulingToLocation: this.findHaulingLocation(
                haulingLocations,
                job.jobLocation,
            ),
            contractId: haulingContractId
        }));
    };

    processSaveResponse = async (response) => {
        if (response.ok) {
            this.resetForm();
            this.notifySuccess();
            this.props.history.push(`${AppNavPaths.Dispatch}`);
        } else {
            let message = '';
            try {
                const responseData = await response.json();
                message = responseData.message;
            } catch (ex) {
                console.warn(ex);
            } finally {
                this.notifyError(message);
                this.resetForm();
            }
        }
    };

    resetForm = () => this.setState({ formValidated: false, saving: false, originalJob: util.object.clone(this.state.job) });

    resourceHasAnyAssignments = (resource) => Boolean(
        resource
        && (resource.monday > 0
            || resource.tuesday > 0
            || resource.wednesday > 0
            || resource.thursday > 0
            || resource.friday > 0
            || resource.saturday > 0
            || resource.sunday > 0),
    );

    resourceIsAfad = (resource) => Boolean(
        resource && resource.isAFAD,
    );

    saveJob = async () => {
        const { job } = { ...this.state };

        const response = await util.fetch.put(
            ApiRoutes.job.update(job.id),
            job,
            util.fetch.format.none,
        );

        this.setPageModified(false);
        this.processSaveResponse(response);
    };

    validateSetupCharges = () => {
        const { job } = this.state;

        if (job.contract.setupChargesRequired) {
            const setupCharges = job.resources.filter((r) => r.setupChargeTypeId > 0);
            let hasSetupCharge = false;

            for (let i = 0; i < setupCharges.length; i++) {
                if (this.resourceHasAnyAssignments(setupCharges[i])) {
                    hasSetupCharge = true;
                    break;
                }
            }

            if (!hasSetupCharge) {
                toasty.error('At least one setup charge is required.');
                return false;
            }
        }

        return true;
    };

    renderResourceHeader = (weekdays, isPlanningOnly) => (
        <thead>
            <tr>
                <th>Resource</th>
                <th>Type</th>

                {weekdays.map((day) => {
                    const existing = this.getExistingOverrideDay(day);
                    const overrideDisabled = this.overrideDayIsDisabled(day);

                    if (isPlanningOnly || (overrideDisabled && !existing) || !this.state.tenantSettings?.tenantSettings.enableJobOverrides) {
                        return (
                            <th
                                key={day}
                                className="resource-weekday-col text-center"
                            >
                                <div className="d-flex flex-column">
                                    <span>
                                        {Weekdays[day.getDay()].abbreviation}
                                    </span>

                                    <span>{moment(day).format('M/D')}</span>
                                </div>
                            </th>
                        );
                    }

                    return (
                        <th
                            key={day}
                            className="resource-weekday-col text-center"
                        >
                            <div className={`d-flex flex-column site-link ${existing && 'text-info'}`} role="button" onClick={() => this.handleClickResourceDay(day)}>
                                <span>
                                    {Weekdays[day.getDay()].abbreviation}
                                </span>

                                <span>{moment(day).format('M/D')}</span>

                                <FontAwesomeIcon
                                    icon={overrideDisabled ? faEye : faEdit}
                                    size="sm"
                                    className="ml-1"
                                />
                            </div>
                        </th>
                    );
                })}
                <th />
            </tr>
        </thead>
    );

    renderResources = (weekdays, isPlanningOnly) => {
        const { job, edit } = { ...this.state };

        if (!job.resources || !(weekdays ?? []).length) {
            return '';
        }

        return job.resources
            .filter((r) => r.isPlanningOnly == Boolean(isPlanningOnly)
                && (r.setupChargeTypeId == null
                    || (r.setupChargeTypeId > 0 && (r.monday > 0 || r.tuesday > 0 || r.wednesday > 0 || r.thursday > 0 || r.friday > 0 || r.saturday > 0 || r.sunday > 0))
                    || (r.setupChargeTypeId > 0 && r.isNew == true)))
            .map((resource, i) => (
                <tr key={resource.resourceName}>
                    <td>
                        <label style={{ marginTop: '2px', marginBottom: 0 }} >{resource.resourceName}</label>
                    </td>
                    <td>{resource.typeName}</td>
                    {weekdays.map((day) => {
                        const dayObj = Weekdays[day.getDay()];
                        const dayName = dayObj.name.toLowerCase();
                        const dayNameHasTimesheet = `${dayName}HasTimesheet`;

                        const resourceIsDisabled = resource[dayNameHasTimesheet] === true
                            || (isPlanningOnly
                                && !this.doesAfadAssignmentExistForDay(
                                    job,
                                    dayName,
                                ));

                        return (
                            <td key={day} className="resource-weekday-column">
                                <input
                                    id={`r${dayName}`}
                                    name={`${dayName}`}
                                    className="w-100"
                                    required
                                    value={resource[dayName]}
                                    onChange={this.onChangeResourceDay.bind(
                                        this,
                                        resource,
                                    )}
                                    readOnly={!edit.allowResources || resource.setupChargeTypeId > 0}
                                    disabled={resourceIsDisabled}
                                    title={
                                        resource[dayNameHasTimesheet] === true
                                            ? 'Approved Timesheet Exists'
                                            : ''
                                    }
                                />
                            </td>
                        );
                    })}
                    <td style={{
                        textAlign: 'center', paddingLeft: '0px', paddingRight: '0px', paddingTop: '7px',
                    }}
                    >
                        {resource.setupChargeTypeId > 0
                            && (
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    title="Remove setup charge"
                                    className="text-danger cursor-pointer"
                                    onClick={() => this.removeSetupCharge(resource)}
                                />
                            )}

                    </td>
                </tr>
            ));
    };

    render() {
        const {
            loading,
            job,
            errors,
            formValidated,
            dispatchLocations,
            saving,
            weeks,
            companyContactsOptions,
            tableRequired,
            meetingLocationRequired,
            jobLocationRequired,
            selectedContact,
            showContactsForm,
            edit,
            resourceTableError,
            showDeleteModal,
            customerSubcontractors,
            contactFormIsReadOnly,
            allowContactTypeEdit,
            tenantSettings,
            showAddSetupCharge,
            showJobOverrideModal,
            currentJobOverride,
            showAddPermitFees,
            pageModified,
            originalJob,
            materials,
            haulingLocations,
            selectedHaulingFromLocation,
            selectedHaulingToLocation
        } = this.state;

        const requestedPersonnelSectionAvailable = this.isRequestedPersonnelSectionAvailable();

        const supportedFiles = SupportedFileExtensions.image
            .concat(SupportedFileExtensions.document)
            .join(',');

        const showConfirmationPrompt = (pageModified || !isEqual(job, originalJob));
        const existing = !!job.id;

        const unusedSetupChargeTypes = job.resources.filter((r) => r.setupChargeTypeId > 0 && !r.isPermit);
        const unusedPermitFees = job.resources.filter((r) => r.setupChargeTypeId > 0 && r.isPermit);

        if (!!loading || !tenantSettings) {
            return <FormCircularProgress />;
        }
        const { jobUploadsEnabled } = {
            ...this.context.tenant.tenantSettings,
        };

        const weekdays = this.getWeekValuesArrayOrdered(job.weekOfDate);

        return (
            <>
                <Prompt
                    when={!!showConfirmationPrompt}
                    message="You have unsaved changes, are you sure you want to leave?"
                />

                <AppPageForm
                    formId="jobForm"
                    formHeadingIcon={faTruck}
                    formHeading={
                        !existing
                            ? 'New Order'
                            : `Edit Order: ${(job.contract ?? {}).number}${job.contractSequence
                                ? `-${job.contractSequence}`
                                : ''
                            }`
                    }
                    formName="jobForm"
                    formRef={this.formRef}
                    onSubmit={this.onSubmit}
                    setIsValidated={(value) => {
                        this.setState({ formValidated: value });
                    }}
                    isValidated={formValidated}
                    saving={saving}
                    errors={errors}
                    loading={this.state.loading}
                >
                    <SubHeading>Contract Details</SubHeading>
                    <GroupedRow>
                        <FormGroupColumn>
                            <FormGroup>
                                <FormLabel
                                    className="mb-1"
                                    htmlFor="contractNumber"
                                    text="Job / Haul Number"
                                />
                                <input
                                    id="contractNumber"
                                    name="contractNumber"
                                    readOnly
                                    className="form-control-plaintext"
                                    defaultValue={
                                        (job.contract ?? {}).number
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <FormLabel
                                    className="mb-1"
                                    htmlFor="contractDescription"
                                    text="Description"
                                />
                                <input
                                    id="contractDescription"
                                    name="contractDescription"
                                    readOnly
                                    className="form-control-plaintext"
                                    defaultValue={
                                        (job.contract ?? {}).description
                                    }
                                />
                            </FormGroup>

                            <FormGroup>
                                <FormLabel
                                    htmlFor="workOrderNumber"
                                    text="Customer Job / Haul #"
                                />
                                <input
                                    id="workOrderNumber"
                                    name="job.workOrderNumber"
                                    className="form-control"
                                    defaultValue={
                                        job.workOrderNumber ?? ''
                                    }
                                    onChange={this.onChange}
                                    readOnly={
                                        !edit.allowWorkOrderNumber
                                    }
                                />
                            </FormGroup>

                        </FormGroupColumn>
                        <FormGroupColumn>
                            <FormGroup>
                                <FormLabel
                                    className="mb-1"
                                    htmlFor="customerName"
                                    text="Customer Name"
                                />
                                <input
                                    id="customerName"
                                    name="customerName"
                                    readOnly
                                    className="form-control-plaintext"
                                    defaultValue={
                                        (job.contract ?? {}).customerName
                                    }
                                />
                            </FormGroup>
                            {(job.contract ?? {}).operationsCenterName && (
                                <FormGroup>
                                    <FormLabel
                                        className="mb-1"
                                        htmlFor="operationsCenterName"
                                        text="Operations Center"
                                    />
                                    <input
                                        id="operationsCenterName"
                                        name="operationsCenterName"
                                        readOnly
                                        className="form-control-plaintext"
                                        defaultValue={
                                            (job.contract ?? {})
                                                .operationsCenterName
                                        }
                                    />
                                </FormGroup>
                            )}
                            <FormGroup>
                                <FormLabel
                                    className="mb-1"
                                    htmlFor="schedule"
                                    text="Schedule"
                                />
                                <input
                                    id="schedule"
                                    name="schedule"
                                    readOnly
                                    className="form-control-plaintext"
                                    defaultValue={
                                        (job.contract ?? {})
                                            .contractScheduleTypeName
                                    }
                                />
                            </FormGroup>
                        </FormGroupColumn>
                    </GroupedRow>
                    <SubHeading>Setup</SubHeading>
                    <GroupedRow>
                        <FormGroupColumn>
                            <FormGroup>
                                <div className="d-flex flex-row flex-nowrap align-items-baseline justify-content-start">
                                    <label
                                        htmlFor="weekOfDate"
                                        className="control-label required"
                                    >
                                        Week Of
                                    </label>
                                </div>

                                <ValidatedSelect
                                    id="weekOfDate"
                                    name="job.weekOfDate"
                                    options={weeks}
                                    value={
                                        weeks.find(
                                            (x) => x.value === job.weekOfDate,
                                        ) ?? ''
                                    }
                                    onChange={this.onSelectChanged}
                                    validationMessage="A week start selection is required."
                                    isDisabled={!edit.allowWeekOfDate}
                                />
                            </FormGroup>
                        </FormGroupColumn>
                        <FormGroupColumn>
                            <FormGroup>
                                <div className="d-flex flex-row flex-nowrap align-items-baseline justify-content-start">
                                    <label
                                        htmlFor="requestedBy"
                                        className="control-label required"
                                    >
                                        Requested By
                                    </label>
                                    {!job.hasAssignments && (
                                        <SmallButton
                                            color="outline-primary"
                                            className="site-button-small mr-2 ml-auto"
                                            onClick={() => this.onAddContact(
                                                'requestedById',
                                            )}
                                        >
                                            <i className="fa fa-plus-circle fa-md mr-2" />
                                            Add Contact
                                        </SmallButton>
                                    )}
                                </div>
                                <ValidatedSelect
                                    id="requestedBy"
                                    name="job.requestedById"
                                    options={companyContactsOptions}
                                    value={
                                        (companyContactsOptions ?? []).find(
                                            (x) => x.value
                                                === job.requestedById,
                                        ) ?? ''
                                    }
                                    onChange={this.onSelectChanged}
                                    required
                                    validationMessage="A requested by selection is required."
                                    isDisabled={!edit.allowRequestedBy}
                                />
                                {!!job?.requestedById && (
                                    <div className="w-100 text-right pr-3">
                                        <small
                                            className="site-link"
                                            onClick={() => this.onEditContact(
                                                'requestedById',
                                            )}
                                        >
                                            Edit Requestor Details
                                        </small>
                                    </div>
                                )}
                            </FormGroup>
                        </FormGroupColumn>
                    </GroupedRow>
                    <GroupedRow>
                        <FormGroupColumn>
                            <FormGroup>
                                <div className="d-flex flex-row flex-nowrap align-items-baseline justify-content-start">
                                    <label
                                        htmlFor="dispatchOfficeLocation"
                                        className="control-label required"
                                    >
                                        Dispatching
                                    </label>
                                </div>
                                <ValidatedSelect
                                    id="dispatchOfficeLocation"
                                    name="job.dispatchOfficeLocationId"
                                    options={dispatchLocations}
                                    value={
                                        (dispatchLocations ?? []).find(
                                            (x) => x.value
                                                === job.dispatchOfficeLocationId,
                                        ) ?? ''
                                    }
                                    onChange={this.onSelectChanged}
                                    required
                                    validationMessage="A dispatch selection is required."
                                    isDisabled={!edit.allowJobLocation}
                                />
                            </FormGroup>
                        </FormGroupColumn>
                        <FormGroupColumn>
                            <FormGroup>
                                <div className="d-flex flex-row flex-nowrap align-items-baseline justify-content-start">
                                    <label
                                        htmlFor="foremenId"
                                        className="control-label required"
                                    >
                                        Foreman
                                    </label>
                                    {!job.hasAssignments && (
                                        <SmallButton
                                            color="outline-primary"
                                            className="site-button-small mr-2 ml-auto"
                                            onClick={() => this.onAddContact(
                                                'foremenId',
                                            )}
                                        >
                                            <i className="fa fa-plus-circle fa-md mr-2" />
                                            Add Contact
                                        </SmallButton>
                                    )}
                                </div>
                                <ValidatedSelect
                                    id="foremen"
                                    name="job.foremenId"
                                    options={companyContactsOptions}
                                    value={
                                        (companyContactsOptions ?? []).find(
                                            (x) => x.value === job.foremenId,
                                        ) ?? ''
                                    }
                                    onChange={this.onSelectChanged}
                                    required
                                    validationMessage="A foremen selection is required."
                                    isDisabled={!edit.allowForemen}
                                />
                                {!!job?.foremenId && (
                                    <div className="w-100 text-right pr-3">
                                        <small
                                            className="site-link"
                                            onClick={() => this.onEditContact(
                                                'foremenId',
                                            )}
                                        >
                                            Edit Foreman Details
                                        </small>
                                    </div>
                                )}
                            </FormGroup>
                            {(job.contract ?? {}).subcontractorsApply && (
                                <FormGroup>
                                    <FormLabel
                                        htmlFor="subcontractor"
                                        text="Subcontractor"
                                        required={
                                            !!job.contract
                                                .subcontractorsApply
                                        }
                                    />
                                    <ValidatedSelect
                                        id="subcontractor"
                                        name="job.subcontractorCompanyId"
                                        options={customerSubcontractors}
                                        value={
                                            (
                                                customerSubcontractors ?? []
                                            ).find(
                                                (x) => x.value
                                                    === job.subcontractorCompanyId,
                                            ) ?? ''
                                        }
                                        onChange={(selection) => {
                                            const { value } = selection;
                                            this.setState(
                                                (state) => (
                                                    (state.job.subcontractorCompanyId = value),
                                                    state
                                                ),
                                            );
                                        }}
                                        required
                                        validationMessage="A subcontractor selection is required."
                                    />
                                </FormGroup>
                            )}
                        </FormGroupColumn>
                    </GroupedRow>
                    <FormDivider />
                    <GroupedRow>
                        <FormGroupColumn>
                            <FormGroup>
                                <FormLabel
                                    htmlFor="startTime"
                                    text="Start Time"
                                    required
                                />
                                <input
                                    id="startTime"
                                    required
                                    type="time"
                                    className="form-control"
                                    name="job.startTime"
                                    defaultValue={job.startTime ?? ''}
                                    onChange={this.onChange}
                                    readOnly={!edit.allowStartTime}
                                />
                                <small className="invalid-feedback text-danger">
                                    Start Time is required.
                                </small>
                            </FormGroup>
                        </FormGroupColumn>

                        <FormGroupColumn>
                            <FormGroup>
                                <FormLabel
                                    htmlFor="materials"
                                    text="Materials"
                                    required
                                />
                                <ValidatedSelect
                                    id="materials"
                                    name="job.materials"
                                    options={materials}
                                    isMulti
                                    required
                                    value={
                                        (materials ?? []).filter((x) => (
                                            job.materials ?? []
                                        ).includes(x.value)) ?? ''
                                    }
                                    onChange={this.onSelectChanged}
                                    validationMessage="A Material selection is required."
                                />
                            </FormGroup>
                        </FormGroupColumn>
                    </GroupedRow>

                    <GroupedRow>
                        <Col>
                            <FormGroup className="mb-0">
                                <FormLabel
                                    text="Resources"
                                    required
                                />
                                <div style={tableRequired}>
                                    <table
                                        className={cls(
                                            'table table-sm table-bordered',
                                            {
                                                'border-top-0':
                                                    this.props.noTopBorder,
                                            },
                                        )}
                                    >
                                        {this.renderResourceHeader(
                                            weekdays,
                                        )}
                                        <tbody>
                                            {!(job.resources ?? [])
                                                .length ? (
                                                    <tr key="emptyRow">
                                                        <td
                                                            colSpan="9"
                                                            className="text-center"
                                                        >
                                                            <small>
                                                                No resources
                                                                found for this
                                                                job.
                                                            </small>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    this.renderResources(
                                                        weekdays,
                                                    )
                                                )}
                                        </tbody>
                                    </table>
                                </div>
                                {!_.isEmpty(tableRequired) && (
                                    <small className="text-danger">
                                        {resourceTableError}
                                    </small>
                                )}
                            </FormGroup>
                        </Col>
                    </GroupedRow>

                    {requestedPersonnelSectionAvailable && (
                        <GroupedRow>
                            <Col>
                                <FormGroup className="mb-0">
                                    <FormLabel
                                        text="Requested Personnel"
                                        required
                                    />
                                    <div style={tableRequired}>
                                        <table
                                            className={cls(
                                                'table table-sm table-bordered',
                                                {
                                                    'border-top-0':
                                                        this.props
                                                            .noTopBorder,
                                                },
                                            )}
                                        >
                                            {this.renderResourceHeader(
                                                weekdays,
                                                true,
                                            )}
                                            <tbody>
                                                {this.renderResources(
                                                    weekdays,
                                                    true,
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </FormGroup>
                            </Col>
                        </GroupedRow>
                    )}

                    {job.contract.setupChargesRequired
                        && (
                            <GroupedRow>
                                <FormGroup>
                                    <div style={{ marginLeft: '30px' }}>
                                        <Button
                                            size="sm"
                                            color="primary"
                                            name="jobForm"
                                            onClick={this.onAddSetupChargeClick}
                                        >
                                            <FontAwesomeIcon
                                                className="mr-2"
                                                icon={faPlus}
                                            />
                                            Add Setup Charge
                                        </Button>
                                    </div>
                                </FormGroup>
                            </GroupedRow>
                        )}

                    {job.contract.permitFeesApply
                        && (
                            <FormGroup style={{ marginBottom: '5px' }}>
                                <div style={{ marginLeft: '30px' }}>
                                    <FormCheckbox
                                        id="permitFeesApply"
                                        name="permitFeesApply"
                                        checked={
                                            job.permitFeesApply ?? ''
                                        }
                                        onChange={this.onPermitFeesApplyChange}
                                        labelText="Permit Fees Apply"
                                    />
                                </div>
                            </FormGroup>
                        )}

                    {job.contract.permitFeesApply && job.permitFeesApply
                        && (
                            <FormGroup>
                                <div style={{ marginLeft: '60px' }}>
                                    <Button
                                        size="sm"
                                        color="secondary"
                                        name="jobForm"
                                        onClick={this.onAddPermitFeesClick}
                                    >
                                        <FontAwesomeIcon
                                            className="mr-2"
                                            icon={faPlus}
                                        />
                                        Add Permit Fees...
                                    </Button>
                                </div>
                            </FormGroup>
                        )}

                    <GroupedRow>
                        <FormGroupColumn>
                            <FormGroup>
                                {job.meetingLocation &&
                                    <>
                                        <table>
                                            <tr>
                                                <td>
                                                    <FormLabel
                                                        htmlFor="meetingLocation"
                                                        text="Haul From"
                                                        required
                                                    />
                                                </td>
                                                <td align="right">
                                                    <div className="bold-link" onClick={() => { this.onEditLocation('globalLocation', 'haulingFromLocation') }}>
                                                        <i className="fa fa-plus-circle"></i>
                                                        &nbsp;Add Location
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>

                                        <ValidatedSelect
                                            id="haulingFromLocation"
                                            name="haulingFromLocation"
                                            options={haulingLocations}

                                            getOptionLabel={this.haulingLocationLabel}
                                            getOptionValue={(option) => option.id}
                                            value={
                                                (haulingLocations ?? []).find(
                                                    (x) => x.id
                                                        === selectedHaulingFromLocation?.id,
                                                ) ?? ''
                                            }
                                            onChange={this.onHaulFromLocationSelected}
                                        />

                                        <div style={{ height: '5px' }}>&nbsp;</div>

                                        <FlexStartRow>
                                            <SmallOutlineButton
                                                onClick={() => {
                                                    this.onEditLocation(
                                                        'meetingLocation',
                                                    );
                                                }}
                                                text="Edit"
                                                disabled={
                                                    !edit.allowMeetingLocation
                                                }
                                            />

                                            {this.hasStreetAddress(job.meetingLocation) &&
                                                <span className="form-control-plaintext">
                                                    {job.meetingLocation.address1}
                                                    {' '}

                                                    {job.meetingLocation.city}
                                                    {', '}

                                                    {job.meetingLocation.state}
                                                    {', '}

                                                    {job.meetingLocation.zip}
                                                    {' '}
                                                </span>
                                            }

                                            {!this.hasStreetAddress(job.meetingLocation) &&
                                                <span className="form-control-plaintext">
                                                    (GPS Only)
                                                </span>
                                            }
                                        </FlexStartRow>
                                    </>
                                }

                                {!job.meetingLocation &&
                                    <>
                                        <table>
                                            <tr>
                                                <td>
                                                    <FormLabel
                                                        htmlFor="meetingLocation"
                                                        text="Haul From"
                                                        required
                                                    />
                                                </td>
                                                <td align="right">
                                                    <div className="bold-link" onClick={() => { this.onEditLocation('globalLocation', 'haulingFromLocation') }}>
                                                        <i className="fa fa-plus-circle"></i>
                                                        &nbsp;Add Location
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>

                                        <ValidatedSelect
                                            id="haulingFromLocation"
                                            name="haulingFromLocation"
                                            options={haulingLocations}
                                            getOptionLabel={this.haulingLocationLabel}
                                            getOptionValue={(option) => option.id}
                                            value={
                                                (haulingLocations ?? []).find(
                                                    (x) => x.id
                                                        === selectedHaulingFromLocation?.id,
                                                ) ?? ''
                                            }
                                            onChange={this.onHaulFromLocationSelected}
                                        />
                                        <div style={{ marginTop: '6px', textAlign: 'right' }} className="site-link" onClick={() => this.onAddLocation('meetingLocation')}>
                                            Edit Address
                                        </div>
                                    </>
                                }
                                {!_.isEmpty(meetingLocationRequired) && (
                                    <small className="text-danger">
                                        Haul From is required.
                                    </small>
                                )}
                            </FormGroup>
                        </FormGroupColumn>
                        <FormGroupColumn>
                            <FormGroup>

                                {job.jobLocation &&
                                    <>
                                        <table>
                                            <tr>
                                                <td>
                                                    <FormLabel
                                                        htmlFor="jobLocation"
                                                        text="Haul To"
                                                        required
                                                    />
                                                </td>
                                                <td align="right">
                                                    <div className="bold-link" onClick={() => { this.onEditLocation('globalLocation', 'haulingToLocation') }}>
                                                        <i className="fa fa-plus-circle"></i>
                                                        &nbsp;Add Location
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>

                                        <ValidatedSelect
                                            id="haulingToLocation"
                                            name="haulingToLocation"
                                            options={haulingLocations}

                                            getOptionLabel={this.haulingLocationLabel}
                                            getOptionValue={(option) => option.id}
                                            value={
                                                (haulingLocations ?? []).find(
                                                    (x) => x.id
                                                        === selectedHaulingToLocation?.id,
                                                ) ?? ''
                                            }
                                            onChange={this.onHaulToLocationSelected}
                                        />

                                        <div style={{ height: '5px' }}>&nbsp;</div>

                                        <FlexStartRow>
                                            <SmallOutlineButton
                                                onClick={() => {
                                                    this.onEditLocation(
                                                        'jobLocation',
                                                    );
                                                }}
                                                text="Edit"
                                                disabled={
                                                    !edit.allowJobLocation
                                                }
                                            />

                                            {this.hasStreetAddress(job.jobLocation) &&
                                                <span className="form-control-plaintext">
                                                    {job.jobLocation.address1}
                                                    {' '}

                                                    {job.jobLocation.city}
                                                    {', '}

                                                    {job.jobLocation.state}
                                                    {', '}

                                                    {job.jobLocation.zip}
                                                    {' '}
                                                </span>
                                            }

                                            {!this.hasStreetAddress(job.jobLocation) &&
                                                <span className="form-control-plaintext">
                                                    (GPS Only)
                                                </span>
                                            }
                                        </FlexStartRow>
                                    </>
                                }

                                {!job.jobLocation &&
                                    <>
                                        <table>
                                            <tr>
                                                <td>
                                                    <FormLabel
                                                        htmlFor="jobLocation"
                                                        text="Haul To"
                                                        required
                                                    />
                                                </td>
                                                <td align="right">
                                                    <div className="bold-link" onClick={() => { this.onEditLocation('globalLocation', 'haulingToLocation') }}>
                                                        <i className="fa fa-plus-circle"></i>
                                                        &nbsp;Add Location
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>

                                        <ValidatedSelect
                                            id="haulingToLocation"
                                            name="haulingToLocation"
                                            options={haulingLocations}
                                            getOptionLabel={this.haulingLocationLabel}
                                            getOptionValue={(option) => option.id}
                                            value={
                                                (haulingLocations ?? []).find(
                                                    (x) => x.id
                                                        === selectedHaulingToLocation?.id,
                                                ) ?? ''
                                            }
                                            onChange={this.onHaulToLocationSelected}
                                        />
                                        <div style={{ marginTop: '6px', textAlign: 'right' }} className="site-link" onClick={() => this.onAddLocation('jobLocation')}>
                                            Edit Address
                                        </div>
                                    </>
                                }

                                {!_.isEmpty(jobLocationRequired) && (
                                    <small className="text-danger">
                                        Haul To is required.
                                    </small>
                                )}
                            </FormGroup>
                        </FormGroupColumn>
                    </GroupedRow>
                    <GroupedRow>
                        <Col>
                            <FormGroup>
                                <FormLabel htmlFor="notes" text="Notes" />
                                <textarea
                                    id="notes"
                                    name="job.notes"
                                    className="form-control"
                                    defaultValue={job.notes ?? ''}
                                    onChange={this.onChange}
                                    placeholder="Enter notes to field staff here."
                                    type="text"
                                    maxLength="500"
                                    rows="5"
                                    readOnly={!edit.allowNotes}
                                />
                            </FormGroup>
                        </Col>
                    </GroupedRow>
                    <FlexCenterRow>
                        <Button
                            size="sm"
                            type="submit"
                            color="primary"
                            name="jobForm"
                        >
                            <FontAwesomeIcon
                                className="mr-2"
                                icon={faSave}
                            />
                            {!existing
                                ? 'Save New Order'
                                : 'Save Order Details'}
                        </Button>
                    </FlexCenterRow>
                    {!!jobUploadsEnabled && (job.id ?? 0) > 0 && (
                        <Row>
                            <Col>
                                <FormGroup>
                                    <FormLabel text="Attach Files" />
                                    <FileUpload
                                        id="jobUploader"
                                        ref={this.uploadsRef}
                                        accept={supportedFiles}
                                        maxNameLength={150}
                                        url={ApiRoutes.job.postAttachments(
                                            job.id,
                                        )}
                                        onUploadComplete={() => this.getAttachments()}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <JobFileAttachments
                                        job={job}
                                        onRemoveAttachment={
                                            this.onRemoveAttachment
                                        }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    )}
                    <FlexCenterRow className="mb-3 mt-4">
                        {edit.allowDelete && (
                            <Button
                                size="sm"
                                type="button"
                                color="danger"
                                name="jobForm"
                                onClick={() => this.setState({ showDeleteModal: true })}
                            >
                                <FontAwesomeIcon
                                    className="mr-2"
                                    icon={faTrashAlt}
                                />
                                Delete Job
                            </Button>
                        )}
                    </FlexCenterRow>
                </AppPageForm>
                <AddressFormNew
                    id="jobAddressForm"
                    ref={this.addressFormRef}
                    contractUsesPrevailingWage={job.contract.prevailingWage}
                    onSaveCallback={(address) => this.onSaveAddress(address)}
                />
                <OrganizationContactForm
                    ref={this.contactFormRef}
                    show={showContactsForm}
                    readOnly={contactFormIsReadOnly}
                    allowContactTypeEdit={allowContactTypeEdit}
                    contact={selectedContact}
                    onClose={() => {
                        this.setState({ showContactsForm: false });
                    }}
                    onChange={(e) => {
                        const { selectedContact } = { ...this.state };
                        selectedContact[e.target.name] = e.target.value;
                        this.setState({
                            newContact: { ...selectedContact },
                        });
                    }}
                    onCheckedChanged={(e) => {
                        const { selectedContact } = { ...this.state };
                        selectedContact[e.target.name] = e.target.checked;
                        this.setState({
                            newContact: { ...selectedContact },
                        });
                    }}
                    onContactTypeChanged={(items) => {
                        const { selectedContact } = this.state;
                        selectedContact.contactTypes = items.map(
                            (x) => x.value,
                        );
                        this.setState({
                            newContact: { ...selectedContact },
                        });
                    }}
                    onSaveCallback={this.onOrganizationContactSaved}
                />
                <Modal isOpen={showDeleteModal}>
                    <ModalHeader>Delete Job</ModalHeader>
                    <ModalBody>
                        Are you sure you want to delete this job?
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={this.onDeleteConfirmed}
                        >
                            Ok
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => this.setState({ showDeleteModal: false })}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={showAddSetupCharge}>
                    <ModalHeader>Add Charge</ModalHeader>
                    <ModalBody>
                        <table className="table table-sm table-bordered table-striped payroll-table">
                            <thead className="text-muted">
                                <tr>
                                    <th style={{ width: '50px' }} />
                                    <th className="invoiceHourlyCharge">
                                        Charge Name
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {!unusedSetupChargeTypes?.length ? (
                                    <tr>
                                        <td
                                            className="text-center"
                                        >
                                            No Charges Available
                                        </td>
                                    </tr>
                                ) : (

                                    unusedSetupChargeTypes?.map(
                                        (
                                            charge,
                                            charge_index,
                                        ) => {
                                            const id = `${charge.id}|${uuid()}`;

                                            return (
                                                <tr
                                                    key={id}
                                                >
                                                    <td style={{ textAlign: 'center' }}>

                                                        <input
                                                            id={id}
                                                            name={id}
                                                            type="checkbox"
                                                            checked={charge.isNew == true}
                                                            onChange={(x) => {
                                                                charge.isNew = x.currentTarget.checked;

                                                                this.setState({
                                                                    charge,
                                                                });

                                                                this.hydrateDriverCharges();
                                                            }}
                                                        />

                                                    </td>
                                                    <td className="invoiceHourlyResource">
                                                        <label htmlFor={id}>
                                                            {
                                                                charge.resourceName
                                                            }
                                                        </label>
                                                    </td>
                                                </tr>
                                            );
                                        },
                                    )
                                )}
                            </tbody>
                        </table>

                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={this.onAddSetupCharge}
                        >
                            Done
                        </Button>
                    </ModalFooter>
                </Modal>

                {Boolean(currentJobOverride) && (
                    <JobOverrideModal
                        edit={edit}
                        open={showJobOverrideModal}
                        jobOverride={currentJobOverride}
                        setFormOpened={this.context.setFormOpened}
                        onClose={this.handleCloseJobOverride}
                        isReadOnly={this.overrideDayIsDisabled(currentJobOverride.overrideDate)}
                        setOverride={this.setPageModified}
                    />
                )}

                <Modal isOpen={showAddPermitFees}>
                    <ModalHeader>Add Permit Fees</ModalHeader>
                    <ModalBody>
                        <table className="table table-sm table-bordered table-striped payroll-table">
                            <thead className="text-muted">
                                <tr>
                                    <th style={{ width: '50px' }} />
                                    <th className="invoiceHourlyCharge">
                                        Charge Name
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {!unusedSetupChargeTypes?.length ? (
                                    <tr>
                                        <td
                                            className="text-center"
                                        >
                                            No Permit Fees Available
                                        </td>
                                    </tr>
                                ) : (

                                    unusedPermitFees?.map(
                                        (
                                            charge,
                                            charge_index,
                                        ) => (
                                            <tr
                                                key={`${charge.id
                                                }|${uuid()}`}
                                            >
                                                <td style={{ textAlign: 'center' }}>

                                                    <input
                                                        type="checkbox"
                                                        checked={charge.isNew == true}
                                                        onChange={(x) => {
                                                            charge.isNew = x.currentTarget.checked;

                                                            this.setState({
                                                                charge,
                                                            });

                                                            this.hydrateDriverCharges();
                                                        }}
                                                    />

                                                </td>
                                                <td className="invoiceHourlyResource">
                                                    {
                                                        charge.resourceName
                                                    }
                                                </td>

                                            </tr>
                                        ),
                                    )
                                )}
                            </tbody>
                        </table>

                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={this.onAddPermitFees}
                        >
                            Done
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
export default withRouter(JobForm);